<ng-container *transloco="let t">
    <form
        [formGroup]="education"
        #ngForm="ngForm"
        fxLayout="column"
        (ngSubmit)="onSubmit($event)"
    >
        <!-- Start flyout-container -->
        <div class="flyout-container">
            <div
                *ngIf="highestLevelOfEducationSelectionId"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field
                        appearance="outline"
                        class="full-width"
                        [floatLabel]="floatLabelControl.value"
                        *ngIf="
                            highestLevelOfEducationSelectionId &&
                                highestLevelOfEducationSelections$
                                | async as highestLevelOfEducationSelections
                        "
                    >
                        <mat-label>{{
                            t("shared.field.highest-education")
                        }}</mat-label>
                        <mat-select
                            formControlName="highestLevelOfEducationSelectionId"
                            [required]="
                                highestLevelOfEducationSelectionId.hasError(
                                    'required'
                                )
                            "
                        >
                            <mat-option
                                *ngFor="
                                    let highestLevelOfEducationSelection of highestLevelOfEducationSelections
                                "
                                [value]="
                                    highestLevelOfEducationSelection.selectionId
                                "
                            >
                                {{ highestLevelOfEducationSelection.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                highestLevelOfEducationSelectionId?.hasError(
                                    'required'
                                )
                            "
                            >{{
                                t("shared.error.required.highest-education")
                            }}</mat-error
                        >
                    </mat-form-field>
                </div>
            </div>
            <div
                *ngIf="highestLevelOfEducationAltSelectionId"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field
                        appearance="outline"
                        class="full-width"
                        [floatLabel]="floatLabelControl.value"
                        *ngIf="
                            highestLevelOfEducationAltSelectionId &&
                                highestLevelOfEducationAltSelections$
                                | async as highestLevelOfEducationAltSelections
                        "
                    >
                        <mat-label>{{
                            t("shared.field.highest-education")
                        }}</mat-label>
                        <mat-select
                            formControlName="highestLevelOfEducationAltSelectionId"
                            [required]="
                                highestLevelOfEducationAltSelectionId.hasError(
                                    'required'
                                )
                            "
                        >
                            <mat-option
                                *ngFor="
                                    let highestLevelOfEducationAltSelection of highestLevelOfEducationAltSelections
                                "
                                [value]="
                                    highestLevelOfEducationAltSelection.selectionId
                                "
                            >
                                {{ highestLevelOfEducationAltSelection.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                highestLevelOfEducationSelectionId?.hasError(
                                    'required'
                                )
                            "
                            >{{
                                t("shared.error.required.highest-education")
                            }}</mat-error
                        >
                    </mat-form-field>
                </div>
            </div>

            <div
                *ngIf="
                    reasonMinorAttendingAdultEducationSelectionId &&
                    is16or17YearsOld
                "
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field
                        appearance="outline"
                        class="full-width"
                        [floatLabel]="floatLabelControl.value"
                        *ngIf="
                            reasonMinorAttendingAdultEducationSelectionId &&
                                reasonMinorAttendingAdultEducationSelections$
                                | async as reasonMinorAttendingAdultEducationSelections
                        "
                    >
                        <mat-label>{{
                            t(
                                "shared.field.reason-minor-attending-adult-education"
                            )
                        }}</mat-label>
                        <mat-select
                            formControlName="reasonMinorAttendingAdultEducationSelectionId"
                            [required]="
                                reasonMinorAttendingAdultEducationSelectionId.hasError(
                                    'required'
                                )
                            "
                        >
                            <mat-option
                                *ngFor="
                                    let reasonMinorAttendingAdultEducationSelection of reasonMinorAttendingAdultEducationSelections
                                "
                                [value]="
                                    reasonMinorAttendingAdultEducationSelection.selectionId
                                "
                            >
                                {{
                                    reasonMinorAttendingAdultEducationSelection.label
                                }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                reasonMinorAttendingAdultEducationSelectionId?.hasError(
                                    'required'
                                )
                            "
                            >{{
                                t(
                                    "shared.error.required.reason-minor-attending-adult-education"
                                )
                            }}</mat-error
                        >
                    </mat-form-field>
                </div>
            </div>

            <div
                *ngIf="lastSchoolAttendedSelectionId && is16or17YearsOld"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{
                            t("shared.field.last-school-attended-selection")
                        }}</mat-label>
                        <mat-select
                            formControlName="lastSchoolAttendedSelectionId"
                            [required]="
                                lastSchoolAttendedSelectionId.hasError(
                                    'required'
                                )
                            "
                            #lastSchoolAttendedSelection
                        >
                            <mat-option>
                                <ngx-mat-select-search
                                    [formControl]="filterLastSchoolAttendedCtrl"
                                    [placeholderLabel]="
                                        t('shared.search-select.search')
                                    "
                                    [noEntriesFoundLabel]="
                                        t(
                                            'shared.search-select.no-entries-found'
                                        )
                                    "
                                    [clearSearchInput]="false"
                                ></ngx-mat-select-search>
                            </mat-option>

                            <mat-option
                                *ngFor="
                                    let selection of filteredLastSchoolAttendedSelections
                                        | async
                                "
                                [value]="selection.selectionId"
                            >
                                {{ selection.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                (lastSchoolAttendedSelectionId?.touched ||
                                    ngForm.submitted) &&
                                lastSchoolAttendedSelectionId?.hasError(
                                    'required'
                                )
                            "
                        >
                            {{
                                t(
                                    "shared.error.required.last-school-attended-selection"
                                )
                            }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div
                *ngIf="reasonLeftSchoolSelectionId"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field
                        appearance="outline"
                        class="full-width"
                        [floatLabel]="floatLabelControl.value"
                        *ngIf="
                            reasonLeftSchoolSelectionId &&
                                reasonLeftSchoolSelections$
                                | async as reasonLeftSchoolSelections
                        "
                    >
                        <mat-label>{{
                            t("shared.field.reason-left-school")
                        }}</mat-label>
                        <mat-select
                            formControlName="reasonLeftSchoolSelectionId"
                            [required]="
                                reasonLeftSchoolSelectionId.hasError('required')
                            "
                        >
                            <mat-option
                                *ngFor="
                                    let reasonLeftSchoolSelection of reasonLeftSchoolSelections
                                "
                                [value]="reasonLeftSchoolSelection.selectionId"
                            >
                                {{ reasonLeftSchoolSelection.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                reasonLeftSchoolSelectionId?.hasError(
                                    'required'
                                )
                            "
                            >{{
                                t("shared.error.required.reason-left-school")
                            }}</mat-error
                        >
                    </mat-form-field>
                </div>
            </div>

            <div
                *ngIf="lastSchoolYear || lastSchoolAttended"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    *ngIf="lastSchoolYear"
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            t("shared.field.last-school-year")
                        }}</mat-label>
                        <input
                            matInput
                            type="number"
                            formControlName="lastSchoolYear"
                            [autocomplete]="'lastSchoolYear' | autocomplete"
                            min="{{ currentYear - 100 }}"
                            max="{{ currentYear }}"
                            maxlength="4"
                            placeholder="{{ currentYear }}"
                            [required]="lastSchoolYear.hasError('required')"
                        />
                        <mat-error
                            *ngIf="lastSchoolYear?.hasError('pattern')"
                            >{{
                                t("shared.error.pattern.last-school-year")
                            }}</mat-error
                        >
                        <mat-error *ngIf="lastSchoolYear?.hasError('required')">
                            {{ t("shared.error.required.last-school-year") }}
                        </mat-error>
                        <mat-error
                            *ngIf="lastSchoolYear?.hasError('futureYear')"
                            >{{ t("shared.error.future-year") }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div
                    *ngIf="lastSchoolAttended"
                    fxFlex="50"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            t("shared.field.last-school-attended")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="lastSchoolAttended"
                            [autocomplete]="'lastSchoolAttended' | autocomplete"
                            maxlength="150"
                            [required]="lastSchoolAttended.hasError('required')"
                        />
                        <mat-error
                            *ngIf="lastSchoolAttended?.hasError('required')"
                        >
                            {{
                                t("shared.error.required.last-school-attended")
                            }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div
                *ngIf="lastSchoolLocation"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline">
                        <mat-label>{{
                            t("shared.field.last-school-location")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="lastSchoolLocation"
                            [autocomplete]="'lastSchoolLocation' | autocomplete"
                            maxlength="200"
                            [required]="lastSchoolLocation.hasError('required')"
                        />
                        <mat-hint>{{
                            t("shared.field.last-school-location-hint")
                        }}</mat-hint>
                        <mat-error
                            *ngIf="lastSchoolLocation?.hasError('required')"
                        >
                            {{
                                t("shared.error.required.last-school-location")
                            }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div
                *ngIf="lastSchoolReasonForLeaving"
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label
                            >{{
                                t(
                                    "shared.field.last-school-reason-for-leaving"
                                )
                            }}{{
                                lastSchoolReasonForLeaving.hasError("required")
                                    ? " *"
                                    : ""
                            }}</mat-label
                        >
                        <input
                            matInput
                            formControlName="lastSchoolReasonForLeaving"
                            [autocomplete]="
                                'lastSchoolReasonForLeaving' | autocomplete
                            "
                            maxlength="200"
                        />
                        <mat-error
                            *ngIf="
                                lastSchoolReasonForLeaving?.hasError('required')
                            "
                        >
                            {{
                                t(
                                    "shared.error.required.last-school-reason-for-leaving"
                                )
                            }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.your-education')?.length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="let trans of t('flyout.your-education')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>
        <!-- End flyout-container -->

        <div *ngIf="schoolingInUSSelectionId">
            <h4>
                {{ t("shared.field.is-schooling-in-us")
                }}{{
                    schoolingInUSSelectionId.hasError("required") ? " *" : ""
                }}
            </h4>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <span class="radio-checkbox-group" fxFlex="100">
                        <mat-radio-group
                            color="primary"
                            formControlName="schoolingInUSSelectionId"
                            *ngIf="
                                schoolingInUSSelections$
                                    | async as schoolingInUSSelections
                            "
                        >
                            <ul>
                                <li
                                    *ngFor="
                                        let schoolingInUSSelection of schoolingInUSSelections
                                    "
                                >
                                    <mat-radio-button
                                        [value]="
                                            schoolingInUSSelection.selectionId
                                        "
                                    >
                                        <span
                                            class="wrap-mat-radio-checkbox-label"
                                        >
                                            {{ schoolingInUSSelection.label }}
                                        </span>
                                    </mat-radio-button>
                                </li>
                            </ul>
                        </mat-radio-group>
                        <mat-error
                            *ngIf="
                                (schoolingInUSSelectionId?.touched ||
                                    ngForm.submitted) &&
                                schoolingInUSSelectionId?.hasError('required')
                            "
                            >{{ t("shared.error.required.is-schooling-in-us") }}
                        </mat-error>
                    </span>
                </div>
            </div>
        </div>

        <div *ngIf="schoolStatusAtEntrySelectionId">
            <h4>
                {{ t("shared.field.school-status-at-entry")
                }}{{
                    schoolStatusAtEntrySelectionId.hasError("required")
                        ? " *"
                        : ""
                }}
            </h4>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field
                        appearance="outline"
                        class="full-width"
                        [floatLabel]="floatLabelControl.value"
                        *ngIf="
                            schoolStatusAtEntrySelectionId &&
                                schoolStatusAtEntrySelections$
                                | async as schoolStatusAtEntrySelections
                        "
                    >
                        <mat-label>{{
                            t("shared.field.school-status-at-entry-hint")
                        }}</mat-label>
                        <mat-select
                            formControlName="schoolStatusAtEntrySelectionId"
                            [required]="
                                schoolStatusAtEntrySelectionId.hasError(
                                    'required'
                                )
                            "
                        >
                            <mat-option
                                *ngFor="
                                    let schoolStatusAtEntrySelection of schoolStatusAtEntrySelections
                                "
                                [value]="
                                    schoolStatusAtEntrySelection.selectionId
                                "
                            >
                                {{ schoolStatusAtEntrySelection.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                schoolStatusAtEntrySelectionId?.hasError(
                                    'required'
                                )
                            "
                            >{{
                                t(
                                    "shared.error.required.school-status-at-entry"
                                )
                            }}</mat-error
                        >
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- Primary Language -->
        <ng-container *ngIf="primaryLanguageSelectionId">
            <h4>{{ t("application.your-education.primary-language") }}</h4>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field
                        appearance="outline"
                        class="full-width"
                        [floatLabel]="floatLabelControl.value"
                        *ngIf="
                            primaryLanguageSelections$
                                | async as primaryLanguageSelections
                        "
                    >
                        <mat-label>{{
                            t("shared.field.primary-language")
                        }}</mat-label>
                        <mat-select
                            formControlName="primaryLanguageSelectionId"
                            [required]="
                                primaryLanguageSelectionId.hasError('required')
                            "
                        >
                            <mat-option
                                *ngFor="
                                    let primaryLanguageSelection of primaryLanguageSelections
                                "
                                [value]="primaryLanguageSelection.selectionId"
                            >
                                {{ primaryLanguageSelection.label }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="
                                primaryLanguageSelectionId?.hasError('required')
                            "
                            >{{
                                t("shared.error.required.primary-language")
                            }}</mat-error
                        >
                    </mat-form-field>
                </div>
            </div>
            <div
                *ngIf="
                    primaryLanguageComment &&
                    this.primaryLanguageSelectionId?.value === 995
                "
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{
                            t("shared.field.primary-language-comment")
                        }}</mat-label>
                        <input
                            matInput
                            formControlName="primaryLanguageComment"
                            [autocomplete]="
                                'primaryLanguageComment' | autocomplete
                            "
                            maxlength="200"
                            [required]="
                                primaryLanguageComment.hasError('required')
                            "
                        />
                        <mat-hint>{{
                            t("shared.field.primary-language-hint")
                        }}</mat-hint>

                        <mat-error
                            *ngIf="primaryLanguageComment?.hasError('required')"
                        >
                            {{
                                t(
                                    "shared.error.required.primary-language-comment"
                                )
                            }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <app-multi-selection-control
            *ngIf="programSelections$ | async as programSelections"
            [formGroup]="education"
            [selections]="programSelections"
            [control]="programSelectionIds"
            formControlName="programSelectionIds"
            [label]="t('shared.group.programs')"
            [requiredMessage]="t('shared.error.required.programs')"
            [formSubmitted]="ngForm.submitted"
        ></app-multi-selection-control>

        <div *ngIf="programSelectionId">
            <h4>
                {{ t("shared.radio-checkbox-group.program-selection")
                }}{{ programSelectionId.hasError("required") ? " *" : "" }}
            </h4>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <span class="radio-checkbox-group" fxFlex="100">
                        <mat-radio-group
                            color="primary"
                            formControlName="programSelectionId"
                            *ngIf="
                                programSingleSelectSelections$
                                    | async as programSingleSelectSelections
                            "
                        >
                            <ul>
                                <li
                                    *ngFor="
                                        let program of programSingleSelectSelections
                                    "
                                >
                                    <mat-radio-button
                                        [value]="program.selectionId"
                                    >
                                        <span
                                            class="wrap-mat-radio-checkbox-label"
                                        >
                                            {{ program.label }}
                                        </span>
                                    </mat-radio-button>
                                </li>
                            </ul>
                        </mat-radio-group>
                        <mat-error
                            *ngIf="
                                (programSelectionId?.touched ||
                                    ngForm.submitted) &&
                                programSelectionId?.hasError('required')
                            "
                            >{{
                                t("shared.error.required.program-selection")
                            }}</mat-error
                        >
                    </span>
                </div>
            </div>
        </div>

        <div class="flyout-container" *ngIf="reasonsForAttendingSelectionIds">
            <app-multi-selection-control
                *ngIf="
                    reasonsForAttendingSelections$
                        | async as reasonsForAttendingSelections
                "
                [formGroup]="education"
                [selections]="reasonsForAttendingSelections"
                [control]="reasonsForAttendingSelectionIds"
                formControlName="reasonsForAttendingSelectionIds"
                [label]="t('shared.group.reasons-for-attending')"
                [requiredMessage]="
                    t('shared.error.required.reasons-for-attending')
                "
                [formSubmitted]="ngForm.submitted"
            ></app-multi-selection-control>
            <mat-card
                appearance="outlined"
                class="sub-title-tooltip why-to-attend"
                [ngClass]="{
                    hidden: t('flyout.reasons-for-attending').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="let trans of t('flyout.reasons-for-attending')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>
        <div
            *ngIf="reasonForAttendingOther"
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="start center"
        >
            <div
                fxFlex="50"
                fxLayoutAlign="start center"
                fxFlex.xs="100"
                fxFlexFill
            >
                <mat-form-field appearance="outline">
                    <mat-label>{{ t("shared.field.other") }}</mat-label>
                    <input
                        matInput
                        formControlName="reasonForAttendingOther"
                        [autocomplete]="
                            'reasonForAttendingOther' | autocomplete
                        "
                        maxlength="50"
                        [required]="
                            reasonForAttendingOther.hasError('required')
                        "
                    />
                    <mat-error
                        *ngIf="reasonForAttendingOther?.hasError('required')"
                    >
                        {{
                            t(
                                "shared.error.required.reason-for-attending-other"
                            )
                        }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="flyout-container" *ngIf="desiredScheduleIds">
            <app-multi-selection-control
                *ngIf="
                    desiredScheduleSelections$
                        | async as desiredScheduleSelections
                "
                [formGroup]="education"
                [selections]="desiredScheduleSelections"
                [control]="desiredScheduleIds"
                formControlName="desiredScheduleIds"
                [label]="t('shared.group.desired-schedule')"
                [requiredMessage]="t('shared.error.required.desired-schedule')"
                [formSubmitted]="ngForm.submitted"
            ></app-multi-selection-control>
            <mat-card
                appearance="outlined"
                class="sub-title-tooltip why-to-attend"
                [ngClass]="{
                    hidden: t('flyout.reasons-for-attending').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container
                        *ngFor="let trans of t('flyout.reasons-for-attending')"
                    >
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <div
            class="flyout-container"
            *ngIf="goalsSelectionIds"
            style="margin-bottom: 100px"
        >
            <app-multi-selection-control
                *ngIf="goalsSelections$ | async as goalsSelections"
                [formGroup]="education"
                [selections]="goalsSelections"
                [control]="goalsSelectionIds"
                formControlName="goalsSelectionIds"
                [label]="t('shared.group.goals')"
                [requiredMessage]="t('shared.error.required.goals')"
                [formSubmitted]="ngForm.submitted"
            ></app-multi-selection-control>
            <mat-card
                appearance="outlined"
                class="sub-title-tooltip"
                [ngClass]="{
                    hidden: t('flyout.goals').length === 0
                }"
            >
                <mat-card-content>
                    <ng-container *ngFor="let trans of t('flyout.goals')">
                        <h2>
                            {{ trans.header }}
                        </h2>
                        <p>
                            {{ trans.text }}
                        </p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <div *ngIf="applicationLocationSelectionId">
            <h4>
                {{ t("shared.field.application-location")
                }}{{
                    applicationLocationSelectionId.hasError("required")
                        ? " *"
                        : ""
                }}
            </h4>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutAlign="start center"
            >
                <div
                    fxFlex="100"
                    fxLayoutAlign="start center"
                    fxFlex.xs="100"
                    fxFlexFill
                >
                    <span class="radio-checkbox-group" fxFlex="100">
                        <mat-radio-group
                            color="primary"
                            formControlName="applicationLocationSelectionId"
                            *ngIf="
                                applicationLocationSelections$
                                    | async as applicationLocationSelections
                            "
                        >
                            <ul>
                                <li
                                    *ngFor="
                                        let applicationLocationSelection of applicationLocationSelections
                                    "
                                >
                                    <mat-radio-button
                                        [value]="
                                            applicationLocationSelection.selectionId
                                        "
                                    >
                                        <span
                                            class="wrap-mat-radio-checkbox-label"
                                        >
                                            {{
                                                applicationLocationSelection.label
                                            }}
                                        </span>
                                    </mat-radio-button>
                                </li>
                            </ul>
                        </mat-radio-group>
                        <mat-error
                            *ngIf="
                                (applicationLocationSelectionId?.touched ||
                                    ngForm.submitted) &&
                                applicationLocationSelectionId?.hasError(
                                    'required'
                                )
                            "
                            >{{
                                t("shared.error.required.application-location")
                            }}
                        </mat-error>
                    </span>
                </div>
            </div>
        </div>

        <button
            mat-stroked-button
            class="submit"
            type="submit"
            [disabled]="submitting"
        >
            {{ t("application.save-and-continue") }}
        </button>
    </form>
</ng-container>
